import createGetters from '@/store/model/getters'

const getters = createGetters()
getters.url = state => { return state.url }
getters.deliveryUrl = state => { return state.deliveryUrl }

export default getters
